<template>
  <b-card>
    <h1>{{ chartTitle }}</h1>
    <vue-apex-charts :options="options" :series="series" type="bar" />
    <mixn ref="mixin" />
  </b-card>
</template>

<script>
import mixn from '@/components/mixn.vue'
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
    BCard,
    mixn,
  },
  props: {
    sumData: {
      type: Array,
      default: () => [],
      required: false,
    },
    chartTitle: {
      type: String,
      default: 'Summations',
    },
  },
  data() {
    return {
      series: [],
      options: {
        chart: {
          height: 350,
          type: 'bar',
        },
        noData: {
          text: 'Search to fetch the data!',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
        stroke: {
          show: true,
          width: 2,
          curve: 'smooth',
        },
        dataLabels: {
          offsetY: -25,
          style: {
            colors: ['#333'],
            fontSize: '12px',
            fontWeight: 'bold',
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
            columnWidth: '50%', // Ajusta este valor para controlar el ancho de las barras
          },
        },
        xaxis: {
          type: 'category',
          tickPlacement: 'on',
        },
        markers: {
          size: 4,
        },
        labels: [],
      },
      dollars: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      }),
    }
  },
  watch: {
    sumData(newData) {
      this.setData()
    },
  },
  methods: {
    setData() {
      if (!this.sumData || this.sumData.length === 0) {
        this.series = []
        return
      }

      const newSeries = [
        {
          name: 'Suma de INS-NC',
          type: 'column',
          data: [],
        },
        {
          name: 'Suma de INS-NP',
          type: 'column',
          data: [],
        },
        {
          name: 'Suma de INS-F/U',
          type: 'column',
          data: [],
        },
        {
          name: 'Suma de INS-R/S',
          type: 'column',
          data: [],
        },
      ]

      this.sumData.forEach(({ income, month, year, facilities }) => {
        const date = `${month}-${year}`
        
        // Contar pacientes desde facilities (no usar totals que son income)
        let nc = 0
        let np = 0
        let fu = 0
        let rs = 0

        if (facilities && Array.isArray(facilities)) {
          facilities.forEach(facility => {
            // Sumar conteos de pacientes por tipo de visita
            nc += facility['INS-NC'] || 0
            np += facility['INS-NP'] || 0
            fu += facility['INS-F/U'] || 0
            rs += facility['INS-R/S'] || 0
          })
        }

        // Solo agregar datos si hay valores mayores a 0
        if (nc > 0 || np > 0 || fu > 0 || rs > 0) {
          newSeries[0].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: nc })
          newSeries[1].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: np })
          newSeries[2].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: fu })
          newSeries[3].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: rs })
        }
      })

      // Filtrar series que tengan datos
      this.series = newSeries.filter(serie => serie.data.length > 0)
      
      this.$nextTick(() => {
        this.options = {
          ...this.options,
          colors: ['#cadbbb', '#fcc599', '#fbd5cc', '#FEB019'],
        }
      })
    },
  },
}
</script>
